module.exports = __webpack_public_path__ + "posture/static/img/low.ed37853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/low.png
// module id = yCic
// module chunks = 1